import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetEmdPassengerReceiptEffect } from './get-emd-passenger-receipt.effect';
import { getEmdPassengerReceiptReducer } from './get-emd-passenger-receipt.reducer';
import { GET_EMD_PASSENGER_RECEIPT_STORE_NAME, GetEmdPassengerReceiptState } from './get-emd-passenger-receipt.state';

/** Token of the GetEmdPassengerReceipt reducer */
export const GET_EMD_PASSENGER_RECEIPT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<GetEmdPassengerReceiptState, Action>
>('Feature GetEmdPassengerReceipt Reducer');

/** Provide default reducer for GetEmdPassengerReceipt store */
export function getDefaultGetEmdPassengerReceiptReducer() {
  return getEmdPassengerReceiptReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_EMD_PASSENGER_RECEIPT_STORE_NAME, GET_EMD_PASSENGER_RECEIPT_REDUCER_TOKEN),
    EffectsModule.forFeature([GetEmdPassengerReceiptEffect]),
  ],
  providers: [
    { provide: GET_EMD_PASSENGER_RECEIPT_REDUCER_TOKEN, useFactory: getDefaultGetEmdPassengerReceiptReducer },
  ],
})
export class GetEmdPassengerReceiptStoreModule {
  public static forRoot<T extends GetEmdPassengerReceiptState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetEmdPassengerReceiptStoreModule> {
    return {
      ngModule: GetEmdPassengerReceiptStoreModule,
      providers: [{ provide: GET_EMD_PASSENGER_RECEIPT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
